import {
  ContractHistoryInstance,
  ContractResponse,
  ParkingSpaceContract,
} from '@models/contract.types';
import { createAsyncTask } from '@stores/taskStore';

import { AGREEMENTS_API_BASE_URL, API_BASE_URL } from './api.constants';
import { generateApiUrl } from './api.utils';
import { authClient } from './client.api';

export const CONTRACT_API_URLS = {
  FETCH_CONTRACT: `${API_BASE_URL}contracts/:id`,
  CONTRACT_DOCUMENT: `${AGREEMENTS_API_BASE_URL}/contract/document`,
  CONTRACT_HISTORY: `${API_BASE_URL}contracts/history`,
  SEPARATELY_INVOICED_PARKING_SPACES: `${API_BASE_URL}contracts/separately-invoiced-parking-spaces`,
  FETCH_PARKING_CONTRACT: `${API_BASE_URL}parking/contracts/:contractId`,
} as const;

export const contractApi = {
  fetchContract: (contractId: string) =>
    authClient.get<ContractResponse>(
      generateApiUrl(CONTRACT_API_URLS.FETCH_CONTRACT, { id: contractId })
    ),
  fetchContractDocument: createAsyncTask(
    'fetch-contract-document',
    ({
      identificationToken,
      contractId,
    }: {
      identificationToken: string;
      contractId: string;
    }) =>
      authClient.post<BlobPart>(
        CONTRACT_API_URLS.CONTRACT_DOCUMENT,
        { identificationToken },
        { params: { contractId }, responseType: 'blob' }
      )
  ),
  fetchContractHistory: () =>
    authClient.get<ContractHistoryInstance[]>(
      CONTRACT_API_URLS.CONTRACT_HISTORY
    ),
  fetchSeparatelyInvoicedParkingSpaces: () =>
    authClient.get<ParkingSpaceContract[]>(
      CONTRACT_API_URLS.SEPARATELY_INVOICED_PARKING_SPACES
    ),
  fetchParkingContract: (contractId: string) =>
    authClient.get<ContractResponse>(
      generateApiUrl(CONTRACT_API_URLS.FETCH_PARKING_CONTRACT, {
        contractId,
      })
    ),
};
